<template>
  <button
    type="button"
    class="fullscreen-btn w-11 h-11 flex items-center justify-center rounded-xl text-gray-600 hover:text-gray-700 dark:text-white/90 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-white/10 transition-all duration-300 shadow-md hover:shadow-lg backdrop-blur-sm hover:scale-105 bg-white dark:bg-gradient-to-br dark:from-[#007aff] dark:to-[#5856d6] border border-black/10 dark:border-white/20"
    @click="toggleFullscreen"
  >
    <i
      class="material-symbols-outlined text-lg"
      id="fullscreenIcon"
    >
      fullscreen
    </i>
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ToggleFullscreenBtn",
  methods: {
    toggleFullscreen() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const element = document.documentElement as any;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const doc = document as any;

      if (!doc.fullscreenElement) {
        // Enter fullscreen mode
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        }
      } else {
        // Exit fullscreen mode
        if (doc.exitFullscreen) {
          doc.exitFullscreen();
        } else if (doc.webkitExitFullscreen) {
          doc.webkitExitFullscreen();
        }
      }
    },
  },
});
</script>
